import { ActionIcon, Button, PostOptionsModal, Text, View } from '@/components'
import { RenderItemProps } from './types'
import { variantProvider, React } from '@/app'
import { useCallback } from 'react'
import { TextBubble } from '../atoms/TextBubble'
import { DebugItem } from './shared'
import { analytics } from '@/services'

const title = 'Contribute with...'

export function FeedPrompt(props: RenderItemProps) {
  const { item } = props

  const modalHeader = (
    <View variants={['row', 'gap:1', 'alignCenter', 'marginBottom:3']}>
      <ActionIcon
        name="chevron-left"
        variants={['minimal', 'neutral10', 'small', 'iconSize:3']}
        debugName="toggle post options modal"
        onPress={() => setTimeout(PostOptionsModal.toggle, 200)}
      />
      <Text variants={['h2', 'textCenter']} text={title} />
    </View>
  )

  const contribute = useCallback(() => {
    PostOptionsModal.open({
      header: modalHeader,
      prompt: item.prompt,
    })
    analytics.track('prompt_contribute_start', {
      prompt_name: item?.prompt?.title,
    })
  }, [])

  return <>
    <DebugItem {...props} />

    <View variants={['paddingHorizontal:2', 'fullWidth']} style={{ zIndex: 1 }}>
      <TextBubble {...TextBubble.extractProps(item.prompt)} style={styles.textBubble} icon="prompt">
        <Button
          variants={['prompt', 'marginTop:2', 'justifyStart', 'border-radius:small']}
          icon={'plus-circle'}
          text={title}
          debugName={'Prompt contribution'}
          onPress={contribute}
        />
      </TextBubble>
    </View>
  </>
}

const styles = variantProvider.createComponentStyle(theme => ({
  textBubble: {
    ...theme.presets.fullWidth,
    ...theme.spacing.padding(2),
    ...theme.spacing.gap(1),
    backgroundColor: theme.colors.neutral1,
  }
}), true)